import React from "react";
import { icons } from "../../assets/icons";

const MFA = () => {
  return (
    <div className="flex justify-between flex-wrap py-2 gap-x-20">
      <div className="flex-1 py-6">
        <div className="font-size-small">
          Use multi-factor authentication to add an extra layer of security to
          your account.
        </div>
        <div className="font-size-small mt-10 mb-4">SMS Based OTP</div>
        <div className="border-[1px] border-[var(--borderGray2)] w-[13.7rem] h-[12.2rem] flex flex-col items-center justify-center rounded-[0.6rem]">
          <img
            className="w-[2.7rem] h-[4.2rem]"
            alt="mobile"
            src={icons.mobileIcon}
          />
          <div className="font-size-small font-family-medium mt-4">
            98765-43210
          </div>
        </div>
        <div className="flex items-center gap-x-2 ml-10 mt-3">
          <img
            src={icons.removeCircleIcon}
            alt="circle minus"
            className="w-[1.7rem] h-[1.7rem]"
          />
          <div className="font-size-small text-[var(--textRed)] underline">
            Remove
          </div>
        </div>
      </div>
    </div>
  );
};

export default MFA;
